// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__9wQfH","Loading__svg":"Loading_Loading__svg__SQceN"};